export default __webpack_public_path__ + "assets/30052c7196df608945b4a33d25cefcda.gif";